import { lazy, Suspense } from 'react';

import { RouteFallback } from '../../ui/RouteFallback';
import { ProtectedRoute } from '../../components/ProtectedRoute';

const OAuthConsentPage = lazy(() => import('../../pages/OAuthConsentPage'));

export const oauthRoutes = [
  {
    path: 'oauth/consent',
    element: (
      <ProtectedRoute>
        <Suspense fallback={<RouteFallback />}>
          <OAuthConsentPage />
        </Suspense>
      </ProtectedRoute>
    ),
  },
];
